module.exports = __webpack_public_path__ + "files/88cc85d52f8b49f8735bb1baf7cd264c.png";